// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"cP-z","carouselContainer":"dP-z"};